import _ from "lodash"
import STRING_CONSTANTS from "../../shared/constants/StringConstants"

export const getSchemeError = (error) => {
  const fieldErrors = _.get(error, "response.data.errors")
  if (_.isPlainObject(fieldErrors)) {
    const first = _.values(fieldErrors)[0]
    if (first) return first
  }
  return _.get(error, "response.data.message") || STRING_CONSTANTS.CONTENT
}
